// extracted by mini-css-extract-plugin
export default {"root":"_2YqN8","image":"_2EBEJ","large":"_3gThS","medium":"_3YyYV","small":"_3EJrk"};